import React from 'react';
import NeighborhoodAccordion from './NeighborhoodAccordion';
import { Neighborhood } from 'apolloClient/types';

interface BasicAccordionProps {
  countyName: string;
  cities: {
    cityName: string;
    neighborhoods: Neighborhood[];
  }[];
  onLinkClick?: () => void;
}

const BasicAccordion: React.FC<BasicAccordionProps> = ({
  countyName,
  cities,
  onLinkClick = () => {},
}) => {
  return (
    <NeighborhoodAccordion
      countyName={countyName}
      cities={cities}
      onLinkClick={onLinkClick}
    />
  );
};

export default BasicAccordion;
